/**
 * Meta (Facebook) Pixel helpers.
 *
 * Wraps window.fbq() so calls are safe to make even before the pixel script
 * loads (or in environments where it's absent, e.g. localhost).
 *
 * Deduplication: pass eventId matching the server-side Conversions API call
 * (use reservation_id) so Meta counts the event once even though it arrives
 * from both the browser and the server.
 */

/**
 * Fire a Meta Pixel event.
 *
 * @param {string} event     - Meta standard event name, e.g. "InitiateCheckout", "Purchase"
 * @param {object} props     - Event properties (value, currency, content_ids, …)
 * @param {string} [eventId] - Optional dedup ID — use reservation_id to match server events
 */
export function fbqTrack(event, props = {}, eventId) {
  try {
    if (typeof window === "undefined" || !window.fbq) return;
    if (eventId) {
      window.fbq("track", event, props, { eventID: String(eventId) });
    } else {
      window.fbq("track", event, props);
    }
  } catch {
    // Never let pixel errors surface to the user
  }
}
